import React from 'react'
import PropTypes from 'prop-types'
import { Box, CircularProgress, Typography, useTheme } from '@material-ui/core'
import { ConfirmationDialog } from 'components'
import useStyles from './styles'

const KanbanCardDeleteDialog = ({
  open,
  setOpen,
  card,
  onConfirm,
  isDeleting,
}) => {
  const classes = useStyles()
  const theme = useTheme()

  const priorityColor =
    {
      high: theme.palette.error.main,
      medium: theme.palette.warning.main,
      low: theme.palette.statuses?.pending || theme.palette.info.main,
    }[card.priority] || '#376FB6'

  return (
    <ConfirmationDialog
      open={open}
      setOpen={setOpen}
      PaperProps={{
        className: classes.confirmPaper,
        style: { borderTop: `4px solid ${priorityColor}` },
      }}
      actionAcceptButton={onConfirm}
      textButton={isDeleting ? <CircularProgress size={16} /> : 'Excluir'}
      textButtonCancel="Cancelar"
      variant="primary"
      hiddenIcon
      disabled={isDeleting}
      text={
        <Box>
          <Typography variant="h4" gutterBottom>
            Você tem certeza que deseja excluir essa atividade?
          </Typography>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            Essa ação é permanente e não poderá ser desfeita.
          </Typography>
          <Box className={classes.confirmBox}>
            <Box className={classes.confirmDot} />
            <Typography variant="body2">
              #{String(card.id).padStart(5, '0')} —{' '}
              {card.name.length > 45 ? card.name.slice(0, 45) + '…' : card.name}
            </Typography>
          </Box>
        </Box>
      }
    />
  )
}

KanbanCardDeleteDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  card: PropTypes.object.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isDeleting: PropTypes.bool,
}

KanbanCardDeleteDialog.defaultProps = {
  isDeleting: false,
}

export default KanbanCardDeleteDialog
